"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosTerminalActivitySchema = exports.APosSignOutReasonSchema = void 0;
const zod_1 = require("zod");
/**
 * TERMINAL ACTIVITY — what a till is doing right now, as shown on the
 * terminal page in platform-app and super admin (one read model, one endpoint:
 * pos-register-service GET /pos/terminals/{terminalId}/activity).
 *
 * Source attributes on the REGISTER row (flat, additive, all optional):
 *   activitySignedIn      {employeeId, employeeName, at, sessionId}  — pos-auth PIN sign-in
 *   activityLastSignOut   {employeeId, employeeName, at, reason}     — pos-auth /pin/logout
 *   activityLastSale      {at, total, type, transactionNumber, employeeId, employeeName} — pos-sales
 *   activityLastSeenAt / activityDisconnectedAt                       — pos-websocket $disconnect
 *
 * Signing out does NOT close the shift (register status `in_session`).
 */
exports.APosSignOutReasonSchema = zod_1.z.enum([
    'signed_out',
    'idle_timeout',
    'session_expired',
    'locked',
    'deregistered',
    'shift_closed',
]);
const PersonRefSchema = zod_1.z.object({
    employeeId: zod_1.z.string().nullable(),
    employeeName: zod_1.z.string().nullable(),
    system: zod_1.z.boolean().optional(),
});
exports.APosTerminalActivitySchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    terminalId: zod_1.z.string(),
    locationId: zod_1.z.string().nullable(),
    registerStatus: zod_1.z.string().nullable(),
    connection: zod_1.z.object({
        online: zod_1.z.boolean(),
        lastSeenAt: zod_1.z.string().nullable(),
        connectedAt: zod_1.z.string().nullable(),
        offlineSince: zod_1.z.string().nullable(),
        heartbeat: zod_1.z.boolean(),
    }),
    signedIn: zod_1.z.object({ employeeId: zod_1.z.string(), employeeName: zod_1.z.string(), at: zod_1.z.string() }).nullable(),
    lastSignOut: zod_1.z.object({
        employeeId: zod_1.z.string(),
        employeeName: zod_1.z.string(),
        at: zod_1.z.string(),
        reason: zod_1.z.string(),
    }).nullable(),
    shift: zod_1.z.object({
        state: zod_1.z.enum(['open', 'closed', 'none']),
        sessionId: zod_1.z.string().nullable(),
        openedAt: zod_1.z.string().nullable(),
        openedBy: PersonRefSchema.nullable(),
        startingCash: zod_1.z.number().nullable(),
        closedAt: zod_1.z.string().nullable(),
        closedBy: PersonRefSchema.nullable(),
        counted: zod_1.z.boolean(),
        variance: zod_1.z.number().nullable(),
        autoClosed: zod_1.z.boolean(),
    }),
    lastSale: zod_1.z.object({
        at: zod_1.z.string(),
        total: zod_1.z.number(),
        type: zod_1.z.string(),
        transactionNumber: zod_1.z.string().nullable(),
        employeeName: zod_1.z.string().nullable(),
    }).nullable(),
    generatedAt: zod_1.z.string(),
});
//# sourceMappingURL=terminal-activity.schema.js.map